import { api } from 'shared';
import { z } from 'zod';

export const CateringFormatsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            slug: z.string(),
        }),
    ),
});
export const fetchCateringFormats = async () => (
    api.get<z.infer<typeof CateringFormatsResponseSchema>>(
        '/catering-formats',
        {
            populate: {
                images: {
                    fields: 'url',
                },
            },
        },
        CateringFormatsResponseSchema,
    )
);
